module.exports = __webpack_public_path__ + "static/android1-a03354f3ff8879f623b895ba6541f35f.jpg";